<template>
  <div style="background:#fff;height:100%">
    <section class="app-section" id="pendingOrders">
      <div class="flex">
        <div class="sectionfl">
          <h6>问卷分类</h6>
          <div style="flex:1;overflow: auto">
            <el-tree
              :data="typeLists"
              node-key="group_id"
              :props="defaultProps"
              :highlight-current="showTree"
              @node-click="handleNodeClick"
              :expand-on-click-node="false"
            >
              <span class="custom-tree-node" slot-scope="{data }">
                <span>{{data.text}}</span>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="sectionfr">
          <Table
            ref="selection"
            :columns="columns"
            :data="list"
            :loading="!haveData"
            @on-selection-change="handleSelect"
          >
            <template slot-scope="{row, index}" slot="action">
              <div>
                <el-button type="text" @click="moveToDetail(row,index)">详情</el-button>
              </div>
            </template>
          </Table>

          <Page
            :total="total"
            :current="current"
            :page-size="size"
            class="pageBox"
            :transfer="true"
            @on-change="changeIndex"
            @on-page-size-change="onSizeChange"
            show-total
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import $ from 'jquery'
import route from '../../../route/config'
export default {
  data() {
    return {
      typeLists: [],
      typeName: '',
      typeCode: '',
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
        },
        {
          title: '团队名称',
          key: 'team_name',
          align: 'center',
        },
        {
          title: '问卷名称',
          key: 'questionnaire_name',
          align: 'center',
        },
        // {
        //   title: '操作',
        //   key: 'action',
        //   width: 100,
        //   slot: 'action',
        //   align: 'center',
        // },
      ],
      showTree: true,
      defaultProps: {
        children: 'children',
        label: 'text',
      },
      list: [],
      haveData: false,
      total: 0,
      current: 1,
      size: 5,
      sizes: [20, 30, 40, 50],
      quesInfo: {},
      index_page: 1,
      SelectData: {},
      creatData: {},
      select: [],
    }
  },
  computed: {
    refreshQues: function () {
      return this.$store.state.refreshQues
    },
    windowHeight: function () {
      return window.innerHeight
    },
  },
  methods: {
    changeIndex(current) {
      this.current = current
      this.getQuesList()
      this.$emit('selectionData', [])
    },
    onSizeChange(size) {
      this.size = size
      this.getList()
    },
    handleNodeClick(data, e) {
      this.creatData = data
      this.typeCode = data.id
      this.typeName = data.text
      this.current = 1
      this.getQuesList()
    },
    column: function (id, index) {
      this.index_page = index
      this.typeCode = id
      this.getQuesList()
    },
    getTypeGroup: function () {
      var self = this
      self.$utils.caringRequest({
        method: 'GET',
        url: self.$utils.getInterface('QUES_CATEGORY_MINI'),
        data: {},
        success: function (res) {
          if (res.code === 0) {
            self.haveData = true
            self.typeLists = res.data
            self.typeCode = res.data[0].id
            self.typeName = res.data[0].text
            self.current = 1

            self.getQuesList()
          } else {
            self.$Message.error(res.message)
          }
        },
      })
    },
    getQuesList: function () {
      var self = this
      self.haveData = false
      self.$utils.caringRequest({
        method: 'GET',
        url: self.$utils.getInterface('QUES_NEWS_MINI'),
        data: {
          category_id: self.typeCode,
          page: self.current,
          size: self.size,
        },

        success: function (res, response) {
          self.haveData = true
          self.total = Number(response['x-total-count']) || 0
          if (res.code === 0) {
            self.list = res.data
          } else {
            self.$Message.error(res.message)
          }
        },
      })
    },
    moveToDetail(row) {
      let _this = this
      _this.$store.commit('clearDataConfig')
      _this.$store.state.quesInfo = {}
      _this.$store.state.quesInfoIndex = -1
      $.ajax({
        type: 'GET',
        url:
          _this.$store.state.INTERFACE.QUESTIONNAIRE +
          '/' +
          row.questionnaire_id,
        cache: false,
        contentType: 'application/json',
        headers: {
          tenant: _this.$store.state.tenant.tenant,
        },
        success: function (res) {
          if (res.code == '0') {
            let moduleLength = res.data.questions.length

            let id =
              res.data.questions[moduleLength - 1].value.innerOrder.split(
                '_'
              )[1] || 0
            _this.$store.commit('setInnerId', id)
            _this.$store.state.questionnaireAttribute =
              res.data.questionnaire.questionnaireAttribute
            res.data.moduleResponse.modules.forEach((item, index) => {
              item.type = 'module'
              item.questionList.forEach((info, _index) => {
                res.data.questions.forEach((ques, __index) => {
                  if (info.value.innerOrder == ques.value.innerOrder) {
                    info.value.id = ques.value.id
                    info.value.questionnaireId = ques.value.questionnaireId
                  }
                })
              })
            })

            _this.$store.state.dataConfig = res.data.moduleResponse.modules

            res.data.questions.forEach((item, index) => {
              if (item.value.innerOrder === '') {
                _this.$store.state.dataConfig.push(item)
              }
            })

            _this.$store.state.dataConfig = _this.$store.state.dataConfig.sort(
              _this.compare('realIndex')
            )

            _this.$store.state.quesName =
              res.data.questionnaire.questionnaireAttribute.name
            _this.$store.state.quesDesc =
              res.data.questionnaire.questionnaireAttribute.prompt

            _this.$store.commit('setSource', 'edit')
            _this.$store.commit('changeQuestId', row.questionnaire_id)
            _this.$emit('isModal', true)
            _this.$store.commit('setAllSelectedKeys', {
              type: 'add',
              name: 'addQues',
              title: route['addQues'].title,
              key: 'addQues',
              extra: {
                id: row.questionnaire_id,
                quesType: 'module',
              },
            })
          } else {
            Message.warning({
              message: res.message,
            })
          }
        },
        error: function () {
          Message.error({
            message: '网络异常，请稍后再试',
          })
        },
      })
    },
    compare: function (realIndex) {
      return function (obj1, obj2) {
        var value1 = obj1[realIndex]
        var value2 = obj2[realIndex]
        return value1 - value2
      }
    },

    handleSelect(selection) {
      const arr = selection.map(s => {
        s.category_name = this.typeName;
        s.category_id = this.typeCode;
        return s;
      })
      this.$emit('selectionData', arr)
    },
  },
  mounted() {
    this.getTypeGroup()
  },
  watch: {
    refreshQues: function () {
      this.getQuesList()
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../../styles/common.less';
.hovers:hover {
  background-color: #e6efff;
}
* {
  font-size: 15px;
}

#pendingOrders {
  .flex {
    background: #fff;
    display: flex;
    height: 90%;
    .sectionfl {
      margin: 0 20px;
      background: #fff;
      width: 320px;
      border: 1px solid #dee3ee;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      min-height: 430px;
      .content {
        width: 320px;
        color: #666;
        height: 54px;
        line-height: 54px;
        text-align: center;
        border-bottom: 1px solid #eeeeee;
        cursor: pointer;
        font-size: 15px;
      }
      h6 {
        width: 318px;
        background: #f6f8fc;
        border-top-right-radius: 6px;
        border-top-left-radius: 6px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-weight: normal;
        font-size: 14px;
        border-bottom: 1px solid #dee3ee;
      }

      .content.active {
        color: #409eff;
      }
    }
    .sectionfr {
      flex: 1;
      position: relative;
      overflow-y: auto;
      padding-right: 30px;
      background: #fff;
    }
  }
  h6 {
    color: #606266;
  }
  ::-webkit-scrollbar {
    /*隐藏滚轮*/
    display: none;
  }
  .bg {
    background: #e6efff;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
}
.pageBox {
  padding-top: 20px;
  float: right;
  position: absolute;
  bottom: 0;
  right: 30px;
}
</style>
